<template>
  <div>
    <v-card
      v-for="access in accesses"
      class="pa-3 mb-2"
      style="border-radius: 15px !important"
    >
      <v-layout class="pa-3" align-center>
        <v-flex lg3 style="text-align: start">
          <p class="subheading grey--text text--darken-2 font-weight-medium">
            Nombre:
          </p>
          <p class="title">
            {{ access.name }}
          </p>
        </v-flex>
        <v-flex lg3 style="text-align: start">
          <p class="subheading grey--text text--darken-2">Tipo:</p>
          <p class="title">
            {{ getGateType(access.gateType) }}
          </p>
        </v-flex>
        <v-flex lg3 style="text-align: start">
          <p class="subheading grey--text text--darken-2">Funcion:</p>
          <p class="title">
            {{ getDirection(access.direction) }}
          </p>
        </v-flex>
        <v-flex lg3 style="text-align: start">
          <QrGenerator :hide="false" :access="access" />
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import QrGenerator from '../../generic/qrGenerator.vue'
export default {
  components: {
    QrGenerator,
  },
  data: () => ({
    accesses: [],
  }),
  mounted() {
    this.getDevices()
  },
  methods: {
    async getDevices() {
      const { data } = await this.$store.dispatch('employee/getAccesses')
      this.accesses = data
    },
    getGateType(gate) {
      const temp = {
        DOOR: 'Puerta',
        BARRIER: 'Pluma',
        TURNSTILE: 'Torniquete',
      }

      return temp[gate] || ''
    },
    getDirection(direction) {
      const temp = {
        IN: 'Entrada',
        OUT: 'Salida',
      }

      return temp[direction] || ''
    },
  },
}
</script>
